const state = {
  svgPaths: {}, // initially empty
  assetCodes: []
};
const getters = {
  assetSVGs: (state) => state.svgPaths,
  assetCodesGetter: (state) => state.assetCodes
};
const actions = {
  async loadEquipmentAsset({ state }, assetId) {
    console.log("Loading asset SVG for assetId:", assetId)
    if (!state.svgPaths[assetId]) {
      // dynamically import image
      let module
      switch (assetId) {
        case "7":
          module = await import('@/assets/dry_n_shine.png')
          break
        case "5":
          module = await import('@/assets/crossover_wraps.png')
          break
        // add more assetIds here
        default:
          return null
      }
      state.svgPaths[assetId] = module.default
    }
    console.log("Loaded SVG path:", state.svgPaths[assetId])
    return state.svgPaths[assetId]
  }
};
const mutations = {
  setSvgPath(state, { assetId, path }) {
    state.svgPaths[assetId] = path
  },
  setAssetCodes(state, assetCodes) {
    state.assetCodes = assetCodes
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};